// extracted by mini-css-extract-plugin
export default {"modal_waiver_ribbon_buttons_container":"ModalWaiverStyles_modal_waiver_ribbon_buttons_container__eJFMc"};